window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.coachingBox = window.locales.am.coachingBox || {};window.locales.am.coachingBox = {...window.locales.am.coachingBox, ...{
    "subtitle": "የእርስዎን ያጠናቅቁ",
    "title": "የማሰልጠኛ ክፍለ ጊዜ",
    "description": "ግቦችዎን ያብራሩ፣ ወደፊት ያለውን ነገር አስቀድመው ይመልከቱ እና ለመግቢያ ቡድናችን ያለዎትን ተነሳሽነት ያሳዩ።",
    "ctaText": "ክፍለ ጊዜ ጀምር",
    "mobileTitle": "የማሰልጠኛ ክፍለ ጊዜዎን ያጠናቅቁ"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.coachingBox = window.locales.ar.coachingBox || {};window.locales.ar.coachingBox = {...window.locales.ar.coachingBox, ...{
    "subtitle": "أكمل",
    "title": "جلسة تدريب",
    "description": "قم بتوضيح أهدافك، واستعرض ما هو قادم، وأظهر دوافعك لفريق القبول لدينا.",
    "ctaText": "بدء الجلسة",
    "mobileTitle": "أكمل جلسة التدريب الخاصة بك"
}
};window.locales.en = window.locales.en || {};window.locales.en.coachingBox = window.locales.en.coachingBox || {};window.locales.en.coachingBox = {...window.locales.en.coachingBox, ...{
    "subtitle": "Complete your",
    "title": "Coaching Session",
    "mobileTitle": "Complete Your Coaching Session",
    "description": "Clarify your goals, preview what's ahead, and demonstrate your motivation to our Admissions team.",
    "ctaText": "Start Session"
}
};window.locales.es = window.locales.es || {};window.locales.es.coachingBox = window.locales.es.coachingBox || {};window.locales.es.coachingBox = {...window.locales.es.coachingBox, ...{
    "subtitle": "Completa tu",
    "title": "Sesión de coaching",
    "description": "Aclare sus objetivos, anticipe lo que le espera y demuestre su motivación a nuestro equipo de Admisiones.",
    "ctaText": "Iniciar sesión",
    "mobileTitle": "Completa tu sesión de coaching"
}
};window.locales.it = window.locales.it || {};window.locales.it.coachingBox = window.locales.it.coachingBox || {};window.locales.it.coachingBox = {...window.locales.it.coachingBox, ...{
    "subtitle": "Completa il tuo",
    "title": "Sessione di coaching",
    "description": "Chiarisci i tuoi obiettivi, dai un'occhiata in anteprima a ciò che ti aspetta e dimostra la tua motivazione al nostro team addetto alle ammissioni.",
    "ctaText": "Inizia sessione",
    "mobileTitle": "Completa la tua sessione di coaching"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.coachingBox = window.locales.zh.coachingBox || {};window.locales.zh.coachingBox = {...window.locales.zh.coachingBox, ...{
    "subtitle": "完成你的",
    "title": "辅导课程",
    "description": "明确您的目标，展望未来，并向我们的招生团队展示您的动机。",
    "ctaText": "开始会话",
    "mobileTitle": "完成你的辅导课程"
}
};